import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import FloatButton from '../../../components/FloatButton/FloatButton';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { main_color_50 } from '../../../styles/_variables';

import styles from './ForumsList.module.scss'
import { Spin } from 'antd';

import { getUser } from '../../../service/user';
import useHeader from '../../../hooks/useHeader';
import ForumItem from '../ForumItem/ForumItem';
import { getForumsByUser } from '../../../service/forum';
import { useUserStore } from '../../../store/useUser';

const ForumsList: React.FC = () => {
  const navigate = useNavigate()
  
  const userId = useUserStore(state => state.id);

  const { data: user, isFetching: isFetchingUser } = useQuery(
    ['user'],
    () => getUser(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const { data: forums, isFetching: isFetchingForums } = useQuery(
    ['forums', userId],
    () => getForumsByUser(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const isFetching = isFetchingForums || isFetchingUser;

  const onClickFloatButton = (e) => {
    navigate('/club/');
  }

  useHeader({ header: user?.fullname, subheader: 'Meus Fóruns' });

  return (
      <div className={styles.container}>
        <HeaderPage header="Meus Fóruns" bageColor={main_color_50}/>
        <Spin spinning={isFetching}>
          {forums?.map(forum => 
            <ForumItem 
              forum={forum}
            />
          )}
        </Spin>
        <FloatButton onClick={onClickFloatButton}/>
      </div>
  )
}

export default ForumsList;